<template>
  <main-layout>
    <!-- <template v-if="isMobile">
      <livechat-mobile></livechat-mobile>
    </template>
    <template v-else>
      <livechat></livechat>
    </template> -->
    <ReplyCommentView></ReplyCommentView>
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import ReplyCommentView from './ReplyCommentView.vue'
import moment from 'moment'

export default {
  data: () => ({
    isMobile: false
  }),
  components: {
    ReplyCommentView
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    var vm = this
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 960
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/RabbitReplyFBPost/main.vue